import {inject} from '@angular/core'
import {OrganizationParametersService} from '@services/organization-parameters.service'

export function orgCalendarTranslation(): {firstDayOfWeek?: number} {
  let firstDayOfWeek: number | null = null
  try {
    firstDayOfWeek = inject(OrganizationParametersService).getFirstDayOfWeekParam()
  } catch {
    return {}
  }

  if (firstDayOfWeek === null || firstDayOfWeek === undefined) {
    return {}
  }

  return {firstDayOfWeek: isNaN(firstDayOfWeek) ? 0 : firstDayOfWeek}
}
